// This is the distance (in px) from the bottom of a scrollable element
// at which we should trigger a scroll event
// 20% of 1250px (4k) ~ 250px
export const SCROLL_TRIGGER_BUFFER = (function () {
  return typeof window !== 'undefined' ? window.innerHeight * 0.2 : 250
})()
